import axios from 'axios'
import Cookies from 'js-cookie'
import Vue from 'vue'
import router from '@router'

export const state = {
  tokenInfo: {
    token: undefined,
    refreshToken: undefined,
    tokenExpiration: undefined,
    info: undefined,
  },
  client_id: process.env.VUE_APP_CLIENT_ID,
  client_secret: process.env.VUE_APP_CLIENT_SECRET,
  redirect_uri: `${process.env.VUE_APP_REDIRECT_URI}/oauth`,
  sessionState: '',
  authCode: undefined,
  authAddress: process.env.VUE_APP_AUTH_ADDRESS,
  tokenAddress: process.env.VUE_APP_TOKEN_ADDRESS,
  pkce_verifier: undefined,
  embed_info: {
    token: undefined,
    embedReports: undefined,
    expiration: undefined,
  },
  cached: [],
  user: {
    email: undefined,
    rep_number: undefined,
    roles: undefined,
    emulation: undefined,
  },
}

export const getters = {
  clientId(state) {
    return state.client_id
  },
  clientSecret(state) {
    return state.client_secret
  },
  redirectUri(state) {
    return state.redirect_uri
  },
  sessionState(state) {
    return state.sessionState
  },
  authCode(state) {
    return state.authCode
  },
  authAddress(state) {
    return state.authAddress
  },
  tokenAddress(state) {
    return state.tokenAddress
  },
  pkceVerifier(state) {
    return state.pkce_verifier
  },
  embedInfo(state) {
    return state.embed_info
  },
  userEmail(state) {
    return state.user.email
  },
  userRepNum(state) {
    return state.user.rep_number
  },
  userRoles(state) {
    return state.user.roles
  },
  emulation(state) {
    return state.user.emulation
  },
}

export const mutations = {
  SET_AUTH_CODE(state, value) {
    state.authCode = value
  },
  SET_SESSION_STATE(state, value) {
    state.sessionState = value
  },
  SET_PKCEV(state, value) {
    state.pkce_verifier = value
    Cookies.set('pkce_verifier', value)
  },
  SET_USER(state, value) {
    state.user.email = value.email
    state.user.roles = value.groups

    Cookies.set('userEmail', value.email)
    Cookies.set('userRoles', JSON.stringify(value.groups))
  },
  SET_ROLE(state, value) {
    state.user.roles = value
    Cookies.set('userRoles', value)
  },
  SET_REPNUM(state, value) {
    if(value) { // never save empty rep number
      state.user.rep_number = value
      Cookies.set('repNumber', value)
    }
  },
  SET_TOKEN(state, token) {
    if (token) {
      const expirationDate = new Date(
        new Date().getTime() + token.expires_in * 1000
      )
      Vue.set(token, 'expiration_date', expirationDate)
      Cookies.set(
        'token',
        JSON.stringify({
          access_token: token.access_token,
          expiration_date: expirationDate,
        }),
        {
          expires: expirationDate,
          path: '',
          sameSite: 'strict',
          secure: process.env.NODE_ENV === 'production',
        }
      )
      state.tokenInfo.info = token
      state.tokenInfo.token = token.access_token
      state.tokenInfo.refreshToken = token.refresh_token
      state.tokenInfo.tokenExpiration = token.expiration_date
    } else {
      if (Cookies.get('token')) Cookies.remove('token', { path: '' })
      state.tokenInfo.info = undefined
      state.tokenInfo.token = undefined
      state.tokenInfo.refreshToken = undefined
      state.tokenInfo.tokenExpiration = undefined
    }
  },
  SET_EMBED_INFO(state, value) {
    state.embed_info.token = value.embedToken.token
    state.embed_info.embedReports = value.embedReport
    state.embed_info.expiration = value.embedToken.expiration
    localStorage.setItem('embed_info', JSON.stringify(Object.assign(value)))
  },
  SET_EMULATION(state, value) {
    state.user.emulation = value
    Cookies.set('emulation', value)
  },
}

export const actions = {
  async login({ getters, commit, dispatch }) {
    var pkceVerifier = generateRandomString()
    commit('SET_PKCEV', pkceVerifier)
    const paramsObj = {
      client_id: getters.clientId,
      client_secret: getters.clientSecret,
      redirect_uri: getters.redirectUri,
      response_type: 'code',
      scope: 'openid',
      code_challenge: await pkceChallengeFromVerifier(pkceVerifier),
      code_challenge_method: 'S256',
      state: 'temp',
    }
    let params = []
    for (const property in paramsObj) {
      const encodedKey = encodeURIComponent(property)
      const encodedValue = encodeURIComponent(paramsObj[property])
      params.push(`${encodedKey}=${encodedValue}`)
    }
    params = `?${params.join('&')}`
    const url = `${getters.authAddress}/${params}`
    setTimeout(() => {
      window.location.href = url
    }, 500)
  },

  async getToken({ getters, commit, dispatch }) {
    // const t = this;
    // return new Promise((resolve, reject) => {
    const url = `${getters.tokenAddress}`
    if (!getters.clientId) {
      console.error('[USERMODULE] Client Id not found!')
    }
    if (!getters.clientSecret) {
      console.error('[USERMODULE] Client Secret not found!')
    }
    if (!getters.redirectUri) {
      console.error('[USERMODULE] Redirect URI not found!')
    }
    if (!getters.authCode) {
      console.error('[USERMODULE] Auth Code not found!')
    }
    // if (!getters.pkceVerifier) {
    //   console.error("[USERMODULE] PKCE Verifier not found!");
    // }
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Basic ${Buffer.from(
        `${getters.clientId}:${getters.clientSecret}`
      ).toString('base64')}`,
      'X-APP-VERSION': '0.0.0',
    }
    const bodyObj = {
      grant_type: 'authorization_code',
      redirect_uri: getters.redirectUri,
      code: getters.authCode,
      code_verifier: Cookies.get('pkce_verifier'),
    }
    let body = []
    for (const property in bodyObj) {
      const encodedKey = encodeURIComponent(property)
      const encodedValue = encodeURIComponent(bodyObj[property])
      body.push(`${encodedKey}=${encodedValue}`)
    }
    body = body.join('&')
    // await axios({
    //   method: 'post',
    //   url: url,
    //   data: body,
    //   headers: headers,
    // }).then(
    //   async (response) => {
    //     debugger
    //     commit('SET_TOKEN', response.data)
    //     commit('SET_AUTH_CODE', undefined) // Reset the auth code so that duplicate attempts are not made
    //     router.push('/')
    //   },
    //   (error) => {
    //     console.error('[USERMODULE] Failed to obtain token!', error)
    //   }
    // )
    var response = await axios({
      method: 'post',
      url: url,
      data: body,
      headers: headers,
    })
    commit('SET_TOKEN', response.data)
    commit('SET_AUTH_CODE', undefined) // Reset the auth code so that duplicate attempts are not made

    var decodedtoken = JSON.parse(
      window.atob(response.data.id_token.split('.')[1])
    )
    commit('SET_USER', decodedtoken)

    if (decodedtoken.pagerNumber) {
      commit('SET_REPNUM', decodedtoken.pagerNumber)
      if (
        decodedtoken.pagerNumber === '000000' ||
        decodedtoken.groups.some(g => g.includes('BI PORTAL POWER USER'))
      ) {
        commit('SET_EMULATION', true)
      } else {
        commit('SET_EMULATION', false)
      }
    } else {
      commit('SET_EMULATION', false)
    }
    router.push('/home')
  },
}

function generateRandomString() {
  const array = new Uint32Array(28)
  window.crypto.getRandomValues(array)
  return Array.from(array, (dec) => `0${dec.toString(16)}`.substr(-2)).join('')
}

function base64urlencode(str) {
  // Convert the ArrayBuffer to string using Uint8 array to conver to what btoa accepts.
  // btoa accepts chars only within ascii 0-255 and base64 encodes them.
  // Then convert the base64 encoded to base64url encoded
  //   (replace + with -, replace / with _, trim trailing =)
  return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}
function sha256(plain) {
  const encoder = new TextEncoder()
  const data = encoder.encode(plain)
  return window.crypto.subtle.digest('SHA-256', data)
}
async function pkceChallengeFromVerifier(v) {
  const hashed = await sha256(v)
  return base64urlencode(hashed)
}
